import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { FATWA_API, cachedFetch, fatwaNum, trunc } from '../utils/api';
import { subscribe } from '../utils/cache';


// ─── Language version helpers ─────────────────────────────────────────────
// Fatwas: root record always has language='ar'. Translations live in
// f.versions = { ar:{question,answer,full_text}, en:{...}, ur:{...} }
// IMPORTANT: fatwas have no 'title' field — only 'question'.
// We set title=question so any code doing `f.title||f.question` works.
function _applyFatwa(f, lang) {
  const v = (f.versions||{})[lang] || (f.versions||{}).ar || {};
  const q = v.question || f.question || '';
  return { ...f, question: q, title: q, answer: v.answer||f.answer||'', full_text: v.full_text||f.full_text||'' };
}
function _filterFatwas(arr, lang) {
  return (arr||[])
    .filter(f => lang==='ar' || (f.versions && f.versions[lang] && f.versions[lang].question))
    .map(f => _applyFatwa(f, lang));
}
// ──────────────────────────────────────────────────────────────────────────
export default function Ticker() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [fatwas, setFatwas] = useState([]);

  useEffect(() => {
    const url = `${FATWA_API}?page=1${lang&&lang!=='ar'?`&language=${lang}`:''}`;

    // Load from cache or network
    cachedFetch(url)
      .then(json => {
        const data = _filterFatwas(json.data, lang).slice(0, 10);
        setFatwas(data);
      })
      .catch(() => {});

    // Update when background revalidation brings fresh data
    const unsub = subscribe(url, (json) => {
      const data = _filterFatwas(json.data, lang).slice(0, 10);
      setFatwas(data);
    });

    return unsub;
  }, [lang]);

  // Double the items so the scroll loop is seamless
  const items = fatwas.length > 0 ? [...fatwas, ...fatwas] : [];

  if (fatwas.length === 0) {
    // Show static placeholder while loading
    return (
      <div className="ticker-wrap">
        <div className="ticker-label">{t('ticker.label')}</div>
        <div className="ticker-track">
          <div className="ticker-items" style={{ animation: 'none', opacity: .4 }}>
            <span style={{ padding: '0 2rem', color: 'rgba(255,255,255,.5)', fontSize: 'var(--t-sm)' }}>
              {t('fb.loading')}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ticker-wrap">
      <div className="ticker-label">{t('ticker.label')}</div>
      <div className="ticker-track">
        <div className="ticker-items">
          {items.map((f, i) => (
            <a
              key={`${f.id}-${i}`}
              href={`/fatwas/${f.id}`}
              onClick={e => { e.preventDefault(); navigate(`/fatwas/${f.id}`); }}
            >
              {fatwaNum(f)} – {trunc(f.question, 60)}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}